import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Company\RoleController::index
* @see app/Http/Controllers/Company/RoleController.php:25
* @route '/companies/{company}/roles'
*/
export const index = (args: { company: string | { id: string } } | [company: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(args, options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/companies/{company}/roles',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Company\RoleController::index
* @see app/Http/Controllers/Company/RoleController.php:25
* @route '/companies/{company}/roles'
*/
index.url = (args: { company: string | { id: string } } | [company: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { company: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { company: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            company: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        company: typeof args.company === 'object'
        ? args.company.id
        : args.company,
    }

    return index.definition.url
            .replace('{company}', parsedArgs.company.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Company\RoleController::index
* @see app/Http/Controllers/Company/RoleController.php:25
* @route '/companies/{company}/roles'
*/
index.get = (args: { company: string | { id: string } } | [company: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Company\RoleController::index
* @see app/Http/Controllers/Company/RoleController.php:25
* @route '/companies/{company}/roles'
*/
index.head = (args: { company: string | { id: string } } | [company: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Company\RoleController::create
* @see app/Http/Controllers/Company/RoleController.php:62
* @route '/companies/{company}/roles/create'
*/
export const create = (args: { company: string | { id: string } } | [company: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(args, options),
    method: 'get',
})

create.definition = {
    methods: ["get","head"],
    url: '/companies/{company}/roles/create',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Company\RoleController::create
* @see app/Http/Controllers/Company/RoleController.php:62
* @route '/companies/{company}/roles/create'
*/
create.url = (args: { company: string | { id: string } } | [company: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { company: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { company: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            company: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        company: typeof args.company === 'object'
        ? args.company.id
        : args.company,
    }

    return create.definition.url
            .replace('{company}', parsedArgs.company.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Company\RoleController::create
* @see app/Http/Controllers/Company/RoleController.php:62
* @route '/companies/{company}/roles/create'
*/
create.get = (args: { company: string | { id: string } } | [company: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Company\RoleController::create
* @see app/Http/Controllers/Company/RoleController.php:62
* @route '/companies/{company}/roles/create'
*/
create.head = (args: { company: string | { id: string } } | [company: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: create.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Company\ToggleCustomRolesController::__invoke
* @see app/Http/Controllers/Company/ToggleCustomRolesController.php:27
* @route '/companies/{company}/roles/toggle-self-service'
*/
export const toggleSelfService = (args: { company: string | { id: string } } | [company: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: toggleSelfService.url(args, options),
    method: 'put',
})

toggleSelfService.definition = {
    methods: ["put"],
    url: '/companies/{company}/roles/toggle-self-service',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Company\ToggleCustomRolesController::__invoke
* @see app/Http/Controllers/Company/ToggleCustomRolesController.php:27
* @route '/companies/{company}/roles/toggle-self-service'
*/
toggleSelfService.url = (args: { company: string | { id: string } } | [company: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { company: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { company: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            company: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        company: typeof args.company === 'object'
        ? args.company.id
        : args.company,
    }

    return toggleSelfService.definition.url
            .replace('{company}', parsedArgs.company.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Company\ToggleCustomRolesController::__invoke
* @see app/Http/Controllers/Company/ToggleCustomRolesController.php:27
* @route '/companies/{company}/roles/toggle-self-service'
*/
toggleSelfService.put = (args: { company: string | { id: string } } | [company: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: toggleSelfService.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Company\RoleController::store
* @see app/Http/Controllers/Company/RoleController.php:71
* @route '/companies/{company}/roles'
*/
export const store = (args: { company: string | { id: string } } | [company: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/companies/{company}/roles',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Company\RoleController::store
* @see app/Http/Controllers/Company/RoleController.php:71
* @route '/companies/{company}/roles'
*/
store.url = (args: { company: string | { id: string } } | [company: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { company: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { company: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            company: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        company: typeof args.company === 'object'
        ? args.company.id
        : args.company,
    }

    return store.definition.url
            .replace('{company}', parsedArgs.company.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Company\RoleController::store
* @see app/Http/Controllers/Company/RoleController.php:71
* @route '/companies/{company}/roles'
*/
store.post = (args: { company: string | { id: string } } | [company: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Company\RoleController::edit
* @see app/Http/Controllers/Company/RoleController.php:84
* @route '/companies/{company}/roles/{role}/edit'
*/
export const edit = (args: { company: string | { id: string }, role: string | { id: string } } | [company: string | { id: string }, role: string | { id: string } ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

edit.definition = {
    methods: ["get","head"],
    url: '/companies/{company}/roles/{role}/edit',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Company\RoleController::edit
* @see app/Http/Controllers/Company/RoleController.php:84
* @route '/companies/{company}/roles/{role}/edit'
*/
edit.url = (args: { company: string | { id: string }, role: string | { id: string } } | [company: string | { id: string }, role: string | { id: string } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            company: args[0],
            role: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        company: typeof args.company === 'object'
        ? args.company.id
        : args.company,
        role: typeof args.role === 'object'
        ? args.role.id
        : args.role,
    }

    return edit.definition.url
            .replace('{company}', parsedArgs.company.toString())
            .replace('{role}', parsedArgs.role.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Company\RoleController::edit
* @see app/Http/Controllers/Company/RoleController.php:84
* @route '/companies/{company}/roles/{role}/edit'
*/
edit.get = (args: { company: string | { id: string }, role: string | { id: string } } | [company: string | { id: string }, role: string | { id: string } ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Company\RoleController::edit
* @see app/Http/Controllers/Company/RoleController.php:84
* @route '/companies/{company}/roles/{role}/edit'
*/
edit.head = (args: { company: string | { id: string }, role: string | { id: string } } | [company: string | { id: string }, role: string | { id: string } ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: edit.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Company\RoleController::show
* @see app/Http/Controllers/Company/RoleController.php:48
* @route '/companies/{company}/roles/{role}'
*/
export const show = (args: { company: string | { id: string }, role: string | { id: string } } | [company: string | { id: string }, role: string | { id: string } ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: '/companies/{company}/roles/{role}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Company\RoleController::show
* @see app/Http/Controllers/Company/RoleController.php:48
* @route '/companies/{company}/roles/{role}'
*/
show.url = (args: { company: string | { id: string }, role: string | { id: string } } | [company: string | { id: string }, role: string | { id: string } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            company: args[0],
            role: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        company: typeof args.company === 'object'
        ? args.company.id
        : args.company,
        role: typeof args.role === 'object'
        ? args.role.id
        : args.role,
    }

    return show.definition.url
            .replace('{company}', parsedArgs.company.toString())
            .replace('{role}', parsedArgs.role.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Company\RoleController::show
* @see app/Http/Controllers/Company/RoleController.php:48
* @route '/companies/{company}/roles/{role}'
*/
show.get = (args: { company: string | { id: string }, role: string | { id: string } } | [company: string | { id: string }, role: string | { id: string } ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Company\RoleController::show
* @see app/Http/Controllers/Company/RoleController.php:48
* @route '/companies/{company}/roles/{role}'
*/
show.head = (args: { company: string | { id: string }, role: string | { id: string } } | [company: string | { id: string }, role: string | { id: string } ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Company\RoleController::update
* @see app/Http/Controllers/Company/RoleController.php:97
* @route '/companies/{company}/roles/{role}'
*/
export const update = (args: { company: string | { id: string }, role: string | { id: string } } | [company: string | { id: string }, role: string | { id: string } ], options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put"],
    url: '/companies/{company}/roles/{role}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Company\RoleController::update
* @see app/Http/Controllers/Company/RoleController.php:97
* @route '/companies/{company}/roles/{role}'
*/
update.url = (args: { company: string | { id: string }, role: string | { id: string } } | [company: string | { id: string }, role: string | { id: string } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            company: args[0],
            role: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        company: typeof args.company === 'object'
        ? args.company.id
        : args.company,
        role: typeof args.role === 'object'
        ? args.role.id
        : args.role,
    }

    return update.definition.url
            .replace('{company}', parsedArgs.company.toString())
            .replace('{role}', parsedArgs.role.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Company\RoleController::update
* @see app/Http/Controllers/Company/RoleController.php:97
* @route '/companies/{company}/roles/{role}'
*/
update.put = (args: { company: string | { id: string }, role: string | { id: string } } | [company: string | { id: string }, role: string | { id: string } ], options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Company\RoleController::destroy
* @see app/Http/Controllers/Company/RoleController.php:113
* @route '/companies/{company}/roles/{role}'
*/
export const destroy = (args: { company: string | { id: string }, role: string | { id: string } } | [company: string | { id: string }, role: string | { id: string } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/companies/{company}/roles/{role}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Company\RoleController::destroy
* @see app/Http/Controllers/Company/RoleController.php:113
* @route '/companies/{company}/roles/{role}'
*/
destroy.url = (args: { company: string | { id: string }, role: string | { id: string } } | [company: string | { id: string }, role: string | { id: string } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            company: args[0],
            role: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        company: typeof args.company === 'object'
        ? args.company.id
        : args.company,
        role: typeof args.role === 'object'
        ? args.role.id
        : args.role,
    }

    return destroy.definition.url
            .replace('{company}', parsedArgs.company.toString())
            .replace('{role}', parsedArgs.role.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Company\RoleController::destroy
* @see app/Http/Controllers/Company/RoleController.php:113
* @route '/companies/{company}/roles/{role}'
*/
destroy.delete = (args: { company: string | { id: string }, role: string | { id: string } } | [company: string | { id: string }, role: string | { id: string } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

const roles = {
    index: Object.assign(index, index),
    create: Object.assign(create, create),
    toggleSelfService: Object.assign(toggleSelfService, toggleSelfService),
    store: Object.assign(store, store),
    edit: Object.assign(edit, edit),
    show: Object.assign(show, show),
    update: Object.assign(update, update),
    destroy: Object.assign(destroy, destroy),
}

export default roles